export function csPluralizationRule (choice) {
    if (choice === 0) {
        return 2
    }
    if (choice === 1) {
        return 0
    }
    if (choice >= 2 && choice <= 4) {
        return 1
    }
    return 2
}

export function choosePluralForm (forms, choice) {
    if (forms.length === 2) {
        return choice === 1 ? forms[0] : forms[1]
    }
    if (forms.length >= 3) {
        return forms[csPluralizationRule(choice)]
    }
    return forms[0]
}
